/**
 * Загрузчик данных из JSON файлов
 */
import { parseCsv } from './csv-parser.js';

export class DataLoader {
  constructor() {
    this.cache = new Map();
  }

  /**
   * Загрузка данных с кэшированием
   * @param {string} url - URL для загрузки
   * @returns {Promise<Object>} - Загруженные данные
   */
  async loadData(url) {
    // Проверяем кэш
    if (this.cache.has(url)) {
      console.log(`📦 Данные загружены из кэша: ${url}`);
      return this.cache.get(url);
    }

    try {
      console.log(`🌐 Загрузка данных: ${url}`);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      // Определяем тип по расширению
      const ext = url.split('.').pop().toLowerCase();
      let data;
      if (ext === 'csv') {
        const text = await response.text();
        data = parseCsv(text);
      } else {
        data = await response.json();
      }

      // Кэшируем данные
      this.cache.set(url, data);

      console.log(`✅ Данные успешно загружены: ${url}`);
      return data;

    } catch (error) {
      console.error(`❌ Ошибка загрузки данных ${url}:`, error);
      throw new Error(`Не удалось загрузить данные из ${url}: ${error.message}`);
    }
  }

  /**
   * Загрузка фильмов
   * @returns {Promise<Object>} - Данные фильмов
   */
  async loadMovies() {
    const data = await this.loadData('/data/price_cvart.csv');
    return { movies: data };
  }

  /**
   * Загрузка категорий
   * @returns {Promise<Object>} - Данные категорий
   */
  async loadCategories() {
    return this.loadData('/data/categories.json');
  }

  /**
   * Очистка кэша
   */
  clearCache() {
    this.cache.clear();
    console.log('🗑️ Кэш очищен');
  }

  /**
   * Получение информации о кэше
   */
  getCacheInfo() {
    return {
      size: this.cache.size,
      urls: Array.from(this.cache.keys()),
    };
  }
}
